<template>
  <form>
    <fieldset class="fieldset">
      <legend>{{ 'Filter'|t }}</legend>
      <div class="expanded row small-up-1 medium-up-2 large-up-4">
        <div class="column">
          <div class="expanded row">
            <div class="column shrink"><label for="command" class="middle">{{ 'Command'|t }}</label></div>
            <div class="column"><input id="command" class="text-center" type="text" v-model="filter.command"></div>
          </div>
        </div>
        <div class="column">
          <div class="expanded row">
            <div class="column shrink"><label for="subject" class="middle">{{ 'Subject'|t }}</label></div>
            <div class="column"><input id="subject" class="text-center" type="text" v-model="filter.object"></div>
          </div>
        </div>
        <div class="column">
          <div class="expanded row">
            <div class="column shrink"><label for="registrar" class="middle">{{ 'Registrar ID'|t }}</label></div>
            <div class="column">
              <div class="column"><input id="registrar" class="text-center" type="number" min="0" v-model="filter.registrar"></div>
            </div>
          </div>
        </div>
        <div class="small-3 columns">
          <div class="expanded button-group">
            <button class="hollow success button" @click.prevent="submitForm()">{{ 'Submit'|t }}</button>
            <button class="hollow primary button" @click.prevent="clearForm()">{{ 'Clear'|t }}</button>
          </div>
        </div>
      </div>
      <a @click="toggleOpen"><i class="icon icon-equalizer2"></i> {{'Toggle filters'|t }}</a>
    </fieldset>

    <div class="callout expanded-filters" v-if="is_open">
      <fieldset class="fieldset">
        <legend>{{ 'Date range'|t }}</legend>
        <div class="expanded row small-up-1 medium-up-2 large-up-3">
          <div class="column">
            <div class="expanded row">
              <div class="column shrink"><label for="date_from" class="middle">{{ 'Date from'|t }}</label></div>
              <div class="column"><input id="date_from" type="date" v-model="filter.date_from"></div>
            </div>
          </div>
          <div class="column">
            <div class="expanded row">
              <div class="column shrink"><label for="date_to" class="middle">{{ 'Date to'|t }}</label></div>
              <div class="column"><input id="date_to" type="date" v-model="filter.date_to"></div>
            </div>
          </div>
          <div class="column">
            <div class="expanded row">
              <div class="column shrink"><label for="session" class="middle">{{ 'Session'|t }}</label></div>
              <div class="column">
                <div class="column"><input id="session" class="text-center" type="text" v-model="filter.session"></div>
              </div>
            </div>
          </div>
        </div>
      </fieldset>
    </div>
  </form>
</template>
<script>
  export default {
    name: 'LogCollectionFilterForm',
    props: {
      value: {
        type: Object,
        default: () => {
          return {
            command: "",
            object: "",
            session: "",
            date_from: "",
            date_to: "",
            registrar: ""
          }
        }
      }
    },
    data() {
      return {
        filter: {
          command: this.value.command || "",
          object: this.value.object || "",
          session: this.value.session || "",
          date_from: this.value.date_from || "",
          date_to: this.value.date_to || "",
          registrar: this.value.hasOwnProperty("registrar") ? this.value.registrar : "",
        },
        is_open: false,
        emit_change: true
      }
    },
    methods: {
      submitForm() {
        let filter = Object.assign({}, this.filter);
        if (filter.registrar === "") {
          delete filter.registrar;
        } else {
          filter.registrar = parseInt(filter.registrar);
        }
        this.$emit('submit', filter)
      },
      clearForm() {
        this.filter = {
          command: "",
          object: "",
          session: "",
          date_from: "",
          date_to: "",
          registrar: ""
        };
        this.is_open = false;
        this.$emit('reset', this.filter)
      },
      toggleOpen() {
        this.is_open = !this.is_open;
      }
    },
    watch: {
      filter: {
        deep: true,
        handler(to) {
          if (this.emit_change) {
            this.$emit('change', to)
          }
          this.emit_change = true;
        }
      },
      value: {
        handler (to) {
          this.emit_change = false;
          this.filter = {
            command: to.command || "",
            object: to.object || "",
            session: to.session || "",
            date_from: to.date_from || "",
            date_to: to.date_to || "",
            registrar: to.hasOwnProperty("registrar") ? to.registrar : "",
          };
          if (this.filter.date_from !== "" || this.filter.date_to !== "" || this.filter.session !== "") {
            this.is_open = true;
          }
        }
      }
    }
  }

</script>



// WEBPACK FOOTER //
// src/components/LogCollectionFilterForm.vue